module.exports = __webpack_public_path__ + "img/logo.2f3697a3.png";